import './App.css';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { RoutesContainer } from './Routes/Routes';
import Navbar from './Components/Navbar';
import Footer from './Components/Footer';
import { useTranslation } from "react-i18next";
import "./i18n"; // Ensure i18n is imported

function AppWrapper() {
  const { i18n } = useTranslation();
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <div
      className='min-h-screen w-screen overflow-hidden'
      dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
    >
      {!isAdminRoute && <Navbar />}
      <main>
        <RoutesContainer />
      </main>
      {!isAdminRoute && <Footer />}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppWrapper />
    </BrowserRouter>
  );
}

export default App;
